import React from "react"
import { HackleExperiment, HackleVariation } from "@hackler/react-sdk"
import { FormattedMessage } from "react-intl"

export default function CtaMessage() {
  return (
    <FormattedMessage id="btn_start_free" />
  )
}
